<script setup lang="ts">
import { useCurrentElement } from '@vueuse/core';
import { ModalElement } from 'inclusive-elements';
import { ref } from 'vue';

import Dialog from '../../components/Dialog.vue';
import type { ReauthenticationStart } from '../types.ts';
import AuthFlow from './AuthFlow.vue';

const props = defineProps<{
    intended?: string;
    start: ReauthenticationStart;
}>();
const emit = defineEmits<{ confirmed: []; close: [] }>();
const el = useCurrentElement<ModalElement>();
const flowOpen = ref(true);
const intended =
    props.intended || `${window.location.pathname}${window.location.search}${window.location.hash}`;

function close() {
    setTimeout(() => (flowOpen.value = false));
    emit('close');
}

function confirmed() {
    emit('confirmed');
    el.value.close();
}
</script>

<template>
    <ui-modal open @close="close">
        <Dialog class="Dialog--small">
            <template #title>Confirm It’s You</template>

            <div class="Dialog-body">
                <AuthFlow
                    v-if="flowOpen"
                    :intended="intended"
                    :start="start"
                    @complete="confirmed"
                />
            </div>
        </Dialog>
    </ui-modal>
</template>
